exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topmenu {\n   padding: 15px 30px 15px 20px;\n   font-size: 17px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sotsys211/work/src/ecard_new/backend/src/app/layout/mainheader/mainheader.component.css
// module id = ../../../../../src/app/layout/mainheader/mainheader.component.css
// module chunks = main